import './error.css'
import logo from './donut.png'
export function ErrorPage(props) {



    return (


        <div class="errorPage">
            <h2 class="errorFirst">Oops! <br></br> Sorry, This Page is Not Found !</h2>
            <div class="errorContainer">
                <h1 class="errorThird">4</h1>
                <div class="donut classic"><span class="icing"></span></div>
                <h1 class="errorThird">4</h1>
            </div>
            <h2 class="errorSecond">Donut worry, <br></br> go back to the previous page.</h2>
        </div>

    );
}


